import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  title: 'Por fin mi viejo dejó de quemar la carne',
  body: "Le regalé este pack a mi papá el año pasado porque siempre le quedaba el asado 'chicloso'. Aplicó el secreto del reposo que sale en el libro y te juro que el último asado parecía de restaurant. Mi mamá es la más feliz porque ahora sí disfruta la carne.",
  author: 'Javiera M.',
  location: 'Providencia',
  result: 'Lomo liso perfecto en 45 min.'
}, {
  title: 'Ahorré 30 lucas en el primer asado',
  body: 'Yo era de los que compraba puro Filete para no fallar. Con el libro aprendí a hacer el Abastero y la Sobrecostilla con la técnica de la salmuera. Gasté la mitad de lo habitual y a mis amigos les encantó. Es el mejor regalo que me han hecho.',
  author: 'Ricardo T.',
  location: 'Concepción',
  result: 'Cortes económicos ultra jugosos.'
}, {
  title: 'Ideal para regalo de última hora',
  body: 'Se me olvidó comprar el regalo y faltaban 2 días. Compré el pack digital, lo imprimí, se lo puse en una carpetita linda y a mi papá le encantó. Ya ha hecho 3 recetas y todas le han salido increíbles. ¡Súper recomendado!',
  author: 'Camila S.',
  location: 'Viña del Mar',
  result: 'Transformación total de domingo.'
}];
export function TestimonialsSection() {
  return <section className="bg-bbq-surface py-24 px-4 border-y border-white/5" data-id="element-158">
      <div className="max-w-6xl mx-auto" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-160">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-white uppercase tracking-wide mb-4" data-id="element-161">
            Familias que ya disfrutan de un{' '}
            <span className="text-bbq-ember" data-id="element-162">verdadero asado</span>
          </h2>
          <div className="flex justify-center gap-1 text-bbq-gold" data-id="element-163">
            {[...Array(5)].map((_, i) => <Star key={i} fill="currentColor" data-id="element-164" />)}
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-165">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-bbq-dark p-8 rounded-xl border border-white/10 relative" data-id="element-166">
              <Quote className="absolute top-6 right-6 text-white/5" size={60} data-id="element-167" />
              <h3 className="text-xl font-display font-bold text-white mb-4 pr-8 leading-tight" data-id="element-168">
                "{t.title}"
              </h3>
              <p className="text-gray-400 mb-6 relative z-10 text-sm md:text-base leading-relaxed" data-id="element-169">
                {t.body}
              </p>
              <div className="border-t border-white/10 pt-4 mt-auto" data-id="element-170">
                <p className="text-white font-semibold" data-id="element-171">{t.author}</p>
                <p className="text-gray-500 text-sm mb-2" data-id="element-172">{t.location}</p>
                <div className="inline-block bg-bbq-surface px-3 py-1 rounded text-xs text-bbq-gold font-medium border border-bbq-gold/20" data-id="element-173">
                  Resultado: {t.result}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}